export const isNotADisplacementKey = (key) => {
    return (key !== "Delete" &&
        key !== "Backspace" &&
        key !== "ArrowLeft" &&
        key !== "ArrowRight" &&
        key !== "Tab");
};
export const truncateReal = (value, length) => {
    const originalLength = value.length;
    const exponentialPosition = Math.max(value.indexOf("e"), value.indexOf("E"));
    const exponentialLength = exponentialPosition >= 0 ? originalLength - exponentialPosition : 0;
    const dotPosition = value.indexOf(".");
    const integerLength = dotPosition >= 0
        ? dotPosition + 1
        : exponentialLength >= 0
            ? originalLength - exponentialLength
            : originalLength;
    const decimalPositions = originalLength - integerLength - exponentialLength;
    const truncatedDecimalPositions = length - integerLength - exponentialLength;
    let finalString = value;
    if (decimalPositions > truncatedDecimalPositions &&
        truncatedDecimalPositions >= 0) {
        const exponentialString = exponentialPosition >= 0 ? value.slice(exponentialPosition) : "";
        const fraction = exponentialPosition >= 0 ? value.slice(0, exponentialPosition) : value;
        const truncatedFraction = round(fraction, truncatedDecimalPositions).toFixed(truncatedDecimalPositions);
        if (isNaN(Number(truncatedFraction))) {
            throw new Error(`cannot truncate ${value} to maximum length ${length}`);
        }
        finalString = `${truncatedFraction}${exponentialString}`;
    }
    else if (truncatedDecimalPositions < 0 &&
        (dotPosition >= 0 || exponentialPosition >= 0)) {
        throw new Error(`cannot truncate ${value} to maximum length ${length}`);
    }
    else if (dotPosition < 0 && exponentialPosition < 0) {
        return value.slice(0, length);
    }
    return finalString;
};
function round(value, decimals) {
    return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);
}
export const isOverMaxLength = (schema, value) => {
    return schema.maxLength ? value.toString().length >= schema.maxLength : false;
};
export const isGreateMaxLength = (schema, value) => {
    return schema.maxLength ? value.toString().length > schema.maxLength : false;
};
const FLOAT_REGEXP = /^[-+]?[0-9]*\.?[0-9]*([0-9]\.?[eEdD][-+]?[0-9]*)?$/;
export function isValidNumber(valueAsString) {
    if (!isNaN(Number(valueAsString)) && isFinite(Number(valueAsString))) {
        return true;
    }
    else if (FLOAT_REGEXP.test(valueAsString)) {
        const valueFilteredWithoutParcialExponential = removeTemporalNumberCharacters(valueAsString);
        return (!isNaN(Number(valueFilteredWithoutParcialExponential)) &&
            isFinite(Number(valueFilteredWithoutParcialExponential)));
    }
    else {
        return false;
    }
}
const INTEGER_REGEXP = /^[-+]?[0-9]*$/;
export function isValidInteger(valueAsString) {
    return INTEGER_REGEXP.test(valueAsString);
}
const EXPONENTIAL_REGEXP = /(\.|(d|e)?(\+|\-)?)$/i;
export function removeTemporalNumberCharacters(numericString) {
    return numericString.replace(EXPONENTIAL_REGEXP, "");
}
export function translateFortranExponetial(numericString) {
    return numericString.replace("D", "E").replace("d", "e");
}
export function getNumericValueFromString(valueAsString) {
    return Number(removeTemporalNumberCharacters(translateFortranExponetial(valueAsString)));
}
export function getValueOrDefault(props) {
    let value = isNotNaN(props.formData) ? props.formData.toString() : "";
    if (value === "" ||
        !isValidNumber(value) ||
        typeof props.formData === "object") {
        value = props.schema
            ? !props.schema.default || typeof props.schema.default === "undefined"
                ? !props.schema.minimum || typeof props.schema.minimum === "undefined"
                    ? 0
                    : props.schema.minimum
                : props.schema.default
            : 0;
    }
    return value.toString();
}
export const isNotNaN = (value) => {
    return value !== null && !isNaN(Number(value));
};
//# sourceMappingURL=utils.js.map